import { cilPlus, cilTrash } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import {
  CBreadcrumb,
  CBreadcrumbItem,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CContainer,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CFormTextarea,
  CHeaderDivider,
  CInputGroup,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import debounce from "debounce";
import "flatpickr/dist/themes/material_green.css";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import "react-datalist-input/dist/styles.css";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import swal from "sweetalert";
import { queryClient } from "../..";
import { customerApi } from "../Helper/customer";
import { addFilterState } from "../Store/reducers/filterReducer";
import {
  checkIsReceived,
  createOrderApi,
  deleteOrderItem,
  fetchCustomerListApi1,
  getOrderPrint,
  getOrderPrintPreviousOrders,
  ItemCustomerList,
  orderEditByIdApi,
  OrderUpdate,
} from "../Helper/order";
import { processDetailHtml } from "../Helper/printHelper";
import "./BillStyles.css";
import "./ordertable.css";

function OrderTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [image, setImage] = useState(null);
  const [imageError, setImageError] = useState(false);
  const [visible, setVisible] = useState(false);
  const [BillModal, setBillModal] = useState(false);
  const [preview, setPreview] = useState();
  const [formErrors, setFormErrors] = useState([]);
  const [formFields, setFormFields] = useState([
    {
      item: "",
      charges: 0,
      type: "",
      orderItemId: "-",
      isComplete: "0",
      isSent: "0",
      isReceived: "0",
      isReturn: "0",
      receivedBy: "",
      itemErr: false,
      chargesErr: false,
      orgIsReceived: false,
      orgIsReturned: false,
      sentDate: "",
    },
  ]);

  //text filed for customer extra info
  const [customerReference, setCustomerReference] = useState("");

  const [customernameError, setCustomernameError] = useState(false);
  const [chargestotal, setchargestotal] = useState(0);
  const [customerlist, setCustomerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [note, setNote] = useState("");
  const [isBillPaid, setIsBillPaid] = useState(false);
  const [orderDate, setorderDate] = useState(moment());
  const [chargesError, setchargesError] = useState();
  const [selectedCustomer, setSelectedCusomer] = useState();

  const [itemorderList, setitemorderList] = useState([]);
  const [additemError, setAdditemError] = useState(false);
  const [OrderPhoto, setOrderPhoto] = useState();
  const [message, setMessage] = useState("");
  let { Id } = useParams();
  const [name, setName] = useState();
  const [contact, setContact] = useState();
  const [customeNoteError, setcustomeNoteError] = useState();
  const [nameErr, setNameErr] = useState();
  const [contactErr, setContactErr] = useState();
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [OrderId, setOrderId] = useState();
  const [printData, setPrintData] = useState();
  const [detailHtmlContent, setDetailHtmlContent] = useState(null);
  const [pendingModal, setPendingModal] = useState(false);
  const printableAreaRef = useRef();
  const [search, setSearch] = useState("");
  const userData = useSelector((state) => state.userData);
  const [totalchargesErr, setTotalchargesErr] = useState(false);
  const [debounceSearch, setDebounceSearch] = useState("");
  const [debounceItemSearch, setDebounceItemSearch] = useState("");
  const [printMode, setPrintMode] = useState("total");
  let userId = userData.userinfo.userId;
  //const [receivedBy, setReceivedBy] = useState("");

  // const getPrintData = async () => {
  //   try {
  //     const res = await getOrderPrint(Id);
  //     if (
  //       res.status === 200 &&
  //       typeof res.data === "string" &&
  //       res.data.trim()
  //     ) {
  //       const parser = new DOMParser();
  //       const doc = parser.parseFromString(res.data, "text/html");

  //       // Extract data from HTML
  //       const header = doc.querySelector(".header");
  //       const orderId = header
  //         ? header
  //             .querySelector("p:nth-child(2)")
  //             .textContent.split(":")[1]
  //             .trim()
  //         : "";
  //       const customerText = header
  //         ? header
  //             .querySelector("p:nth-child(3)")
  //             .textContent.split(":")[1]
  //             .trim()
  //         : "";
  //       const customerName = customerText.split(" (")[0];
  //       const customerPhone =
  //         customerText.split(" (")[1]?.replace(")", "") || "";
  //       const orderDate = header
  //         ? header
  //             .querySelector("p:nth-child(4)")
  //             .textContent.split(":")[1]
  //             .trim()
  //         : "";

  //       const table = doc.querySelector("table");
  //       const rows = table ? table.querySelectorAll("tbody tr") : [];
  //       const orderItems = Array.from(rows).map((row, index) => {
  //         const cells = row.querySelectorAll("td");
  //         return {
  //           item: cells[0]?.textContent.trim() || "", // Item column
  //           type: cells[1]?.textContent.trim() || "", // Type column
  //           charges: cells[2]?.textContent.trim() || "", // Charges column
  //         };
  //       });

  //       const totalDiv = doc.querySelector(".total");
  //       const totalCharges = totalDiv
  //         ? totalDiv
  //             .querySelector("p:first-child")
  //             .textContent.split(":")[1]
  //             .trim()
  //         : "";
  //       const preOrderTotalCharges =
  //         totalDiv && totalDiv.querySelector("p:nth-child(2)")
  //           ? totalDiv
  //               .querySelector("p:nth-child(2)")
  //               .textContent.split(":")[1]
  //               .trim()
  //           : "";

  //       const qrImg = doc.querySelector('img[alt="barcode"]');
  //       const qrCode = qrImg ? qrImg.src.split(",")[1] : null;

  //       const extractedData = {
  //         orderId,
  //         customerName,
  //         customerPhone,
  //         orderDate,
  //         orderItems,
  //         totalCharges,
  //         preOrderArray: [], // Not present in HTML, set empty
  //         preOrderTotalCharges,
  //         qrCode,
  //       };

  //       return extractedData;
  //     } else {
  //       return null;
  //     }
  //   } catch (error) {
  //     console.error("API call failed:", error);
  //     return null;
  //   }
  // };

  // const getPrintData = async () => {
  //   try {
  //     const res = await getOrderPrint(Id);
  //     if (
  //       res.status === 200 &&
  //       typeof res.data === "string" &&
  //       res.data.trim()
  //     ) {
  //       const parser = new DOMParser();
  //       const doc = parser.parseFromString(res.data, "text/html");

  //       // Extract data from HTML
  //       const header = doc.querySelector(".header");
  //       const orderId = header
  //         ? header
  //             .querySelector("p:nth-child(1)")
  //             ?.textContent.split(":")[1]
  //             ?.trim() || ""
  //         : "";

  //       const customerText = header
  //         ? header
  //             .querySelector("p:nth-child(2)")
  //             ?.textContent.split(":")[1]
  //             ?.trim() || ""
  //         : "";

  //       const customerName = customerText.split(" (")[0]?.trim() || "";
  //       const customerPhone =
  //         customerText.split(" (")[1]?.replace(")", "")?.trim() || "";

  //       const orderDate = header
  //         ? header
  //             .querySelector("p:nth-child(3)")
  //             ?.textContent.split(":")[1]
  //             ?.trim() || ""
  //         : "";

  //       const table = doc.querySelector("table");
  //       const rows = table ? table.querySelectorAll("tbody tr") : [];
  //       const orderItems = Array.from(rows).map((row) => {
  //         const cells = row.querySelectorAll("td");
  //         // Remove ₹ symbol and trim
  //         const chargesText = cells[2]?.textContent.trim() || "";
  //         const charges = chargesText.replace("₹", "").trim();

  //         return {
  //           item: cells[0]?.textContent.trim() || "",
  //           type: cells[1]?.textContent.trim() || "",
  //           charges: charges,
  //         };
  //       });

  //       const totalDiv = doc.querySelector(".total");
  //       const totalChargesText = totalDiv
  //         ? totalDiv
  //             .querySelector("p:first-child")
  //             ?.textContent.split(":")[1]
  //             ?.trim() || ""
  //         : "";
  //       const totalCharges = totalChargesText.replace("₹", "").trim();

  //       const preOrderText =
  //         totalDiv && totalDiv.querySelector("p:nth-child(2)")
  //           ? totalDiv
  //               .querySelector("p:nth-child(2)")
  //               ?.textContent.split(":")[1]
  //               ?.trim() || ""
  //           : "";
  //       const preOrderTotalCharges = preOrderText.replace("₹", "").trim();

  //       const qrImg = doc.querySelector('img[alt="barcode"]');
  //       const qrCode = qrImg ? qrImg.src.split(",")[1] : null;

  //       const extractedData = {
  //         orderId,
  //         customerName,
  //         customerPhone,
  //         orderDate,
  //         orderItems,
  //         totalCharges,
  //         preOrderArray: [],
  //         preOrderTotalCharges,
  //         qrCode,
  //       };

  //       console.log("✅ Extracted Print Data:", extractedData); // Add this for debugging
  //       return extractedData;
  //     } else {
  //       console.error("❌ Invalid API response");
  //       return null;
  //     }
  //   } catch (error) {
  //     console.error("❌ API call failed:", error);
  //     return null;
  //   }
  // };

  const getPrintData = async () => {
    try {
      console.log("🔍 Calling getOrderPrint with ID:", Id);
      const res = await getOrderPrint(Id);

      // Check if response exists
      if (!res) {
        return null;
      }

      // Check multiple response formats
      let htmlContent = null;

      // Case 1: res.data is a string (HTML)
      if (typeof res.data === "string" && res.data.trim()) {
        htmlContent = res.data;
      }
      // Case 2: res is a string (HTML) directly
      else if (typeof res === "string" && res.trim()) {
        htmlContent = res;
      }
      // Case 3: Axios response with data property
      else if (res.status === 200 && res.data) {
        htmlContent = res.data;
      }

      if (!htmlContent || typeof htmlContent !== "string") {
        return null;
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");

      // Extract data from HTML
      const header = doc.querySelector(".header");

      if (!header) {
        return null;
      }

      const orderId =
        header
          .querySelector("p:nth-child(1)")
          ?.textContent.split(":")[1]
          ?.trim() || "";
      const customerText =
        header
          .querySelector("p:nth-child(2)")
          ?.textContent.split(":")[1]
          ?.trim() || "";
      const customerName = customerText.split(" (")[0]?.trim() || "";
      const customerPhone =
        customerText.split(" (")[1]?.replace(")", "")?.trim() || "";
      const orderDate =
        header
          .querySelector("p:nth-child(3)")
          ?.textContent.split(":")[1]
          ?.trim() || "";

      const table = doc.querySelector("table");
      const rows = table ? table.querySelectorAll("tbody tr") : [];

      const orderItems = Array.from(rows).map((row) => {
        const cells = row.querySelectorAll("td");
        const hasSr = cells.length >= 4;
        const chargesText = (hasSr ? cells[3]?.textContent.trim() : cells[2]?.textContent.trim()) || "";
        const charges = chargesText.replace("₹", "").trim();

        return {
          item: (hasSr ? cells[1]?.textContent.trim() : cells[0]?.textContent.trim()) || "",
          type: (hasSr ? cells[2]?.textContent.trim() : cells[1]?.textContent.trim()) || "",
          charges: charges,
        };
      });

      const totalDiv = doc.querySelector(".total");
      const totalChargesText =
        totalDiv
          ?.querySelector("p:first-child")
          ?.textContent.split(":")[1]
          ?.trim() || "";
      const totalCharges = totalChargesText
        .replace("₹", "")
        .replace(",", "")
        .trim();

      const preOrderText =
        totalDiv
          ?.querySelector("p:nth-child(2)")
          ?.textContent.split(":")[1]
          ?.trim() || "";
      const preOrderTotalCharges = preOrderText
        .replace("₹", "")
        .replace(",", "")
        .trim();

      const qrImg = doc.querySelector('img[alt="barcode"]');
      const qrCode = qrImg ? qrImg.src.split(",")[1] : null;

      const extractedData = {
        orderId,
        customerName,
        customerPhone,
        orderDate,
        orderItems,
        totalCharges,
        preOrderArray: [],
        preOrderTotalCharges,
        qrCode,
      };

      return extractedData;
    } catch (error) {
      return null;
    }
  };

  const handleDateChange = (date) => {
    setorderDate(date);
  };
  const isEditMode = !!Id;

  const debouncedSearch = useCallback(
    debounce((value) => setDebounceSearch(value), 800),
    [],
  );

  const debouncedItemSearch = useCallback(
    debounce((value) => setDebounceItemSearch(value), 800),
    [],
  );

  const getCustomerList = () => {
    fetchCustomerListApi1(debounceSearch).then(
      (res) => {
        var data = res.data;
        var customerLive = [];
        data.forEach((element) => {
          customerLive.push({
            value: element.customerId,
            label:
              element.customerName + " " + "(" + element.customerPhone + ")",
          });
        });
        setCustomerList(customerLive);
      },
      (err) => {},
    );
  };

  useEffect(() => {
    if (isEditMode) {
      getorderDataForEdit();
    }
  }, [isEditMode]);

  useEffect(() => {
    getCustomerList();
  }, [debounceSearch]);

  // Refresh customer list when window regains focus (e.g., after adding customer in another tab)
  useEffect(() => {
    const handleFocus = () => {
      getCustomerList();
    };

    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("focus", handleFocus);
    };
  }, []);

  useEffect(() => {
    fetchitemlist();
  }, [debounceItemSearch]);

  // Load all items on component mount to populate datalist
  useEffect(() => {
    ItemCustomerList("").then((res) => {
      var data = res.data;
      var itemlistLive = [];
      data.forEach((element) => {
        itemlistLive.push({
          value: element.itemName,
          label: element.itemName,
        });
      });
      setitemorderList(itemlistLive);
    });
  }, []);

  const fetchitemlist = () => {
    ItemCustomerList(search).then(
      (res) => {
        var data = res.data;
        var itemlistLive = [];
        data.forEach((element) => {
          itemlistLive.push({
            value: element.itemName,
            label: element.itemName,
          });
        });
        setitemorderList(itemlistLive);
      },
      (err) => {},
    );
  };

  useEffect(() => {
    if (!image) {
      setPreview(undefined);
      return;
    }
    const objectUrl = URL.createObjectURL(image);
    if (image.type === "image/png" || image.type === "image/jpeg") {
      setPreview(objectUrl);
    } else {
      setPreview(null);
    }

    return () => URL.revokeObjectURL(objectUrl);
  }, [image]);

  // Open modal when printData is ready for edit mode
  useEffect(() => {
    if (pendingModal && printData && Id) {
      setBillModal(true);
      setPendingModal(false);
    }
  }, [printData, pendingModal, Id]);

  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();

    formFields.map((e, index) => {
      if (e.item == "") {
        let data = [...formFields];
        data[index]["itemErr"] = true;
        setFormFields(data);
      }
      if (e.charges <= 0) {
        let data = [...formFields];
        data[index]["chargesErr"] = true;
        setFormFields(data);
      }
    });

    const formm = event.currentTarget;
    if (formm.checkValidity() === false) {
      event.preventDefault();
      setLoading(false);
    } else {
      let totalpay = 0;
      formFields.map((e) => {
        totalpay = totalpay + parseFloat(e.charges);
      });

      if (chargestotal <= 0 || !chargestotal || chargestotal !== totalpay) {
        setTotalchargesErr(true);
        setLoading(false);
        return;
      } else {
        setTotalchargesErr(false);
      }

      if (selectedCustomer && selectedCustomer != "0") {
        const preparedFormFields = formFields.map((field) => ({
          ...field,
          isReturn: field.isReturn || "0",
          isComplete: field.isComplete || "0",
          isSent: field.isSent || "0",
          isReceived: field.isReceived || "0",

          receivedBy:
            field.isSent === "1" &&
            (!field.receivedBy || field.receivedBy.trim() === "")
              ? customerName
              : field.receivedBy || "",
          type: field.type || "",
          item: field.item || "",
          charges: field.charges || "0",
        }));

        if (Id === undefined) {
          const formData = new FormData();
          formData.append("userId", userData.userinfo.userId);
          formData.append(
            "customerId",
            selectedCustomer?.value || selectedCustomer,
          );
          formData.append("orderItems", JSON.stringify(preparedFormFields));
          formData.append("totalCharges", chargestotal);
          formData.append("note", note);
          formData.append("orderPhoto", image ?? "");
          formData.append("orderDate", moment(orderDate).format("YYYY-MM-DD"));
          formData.append("isBillPaid", isBillPaid ? "1" : "0");
          formData.append("customerReference", customerReference);

          await createOrderApi(formData).then(async (res) => {
            if (res.status === 200) {
              setOrderId(res.orderId);

              // Fetch the appropriate HTML content based on printMode
              try {
                const fetchApi = printMode === "detail" 
                  ? getOrderPrintPreviousOrders(res.orderId) 
                  : getOrderPrint(res.orderId);
                
                const htmlRes = await fetchApi;
                if (htmlRes) setDetailHtmlContent(processDetailHtml(htmlRes, { hideQr: printMode === "total" }));
              } catch (error) {
                console.error(`Failed to fetch ${printMode} HTML:`, error);
              }

              setPrintData({
                customerName: customerName,
                customerPhone: customerPhone,
                orderId: res.orderId,
                orderDate: orderDate.format("DD-MM-YYYY"),
                orderItems: preparedFormFields,
                totalCharges: chargestotal,
                preOrderArray: [],
                preOrderTotalCharges: 0,
              });
              setBillModal(true);
              const custId = selectedCustomer?.value || selectedCustomer;
              if (custId) {
                dispatch(addFilterState({ 
                  customerId: custId,
                  customerName: customerName,
                  searchQuery: "",
                  showStartDate: "",
                  showEndDate: "",
                  startDate: "",
                  endDate: ""
                }));
              }
              setMessage(res.message);
              setOrderId(res.orderId);
              queryClient.invalidateQueries(["order-data-list"]);
            } else {
              swal("Error", res.message, "warning");
            }
          });
          setLoading(false);
          setImageError(false);
        } else {
          const formData = new FormData();
          formData.append("userId", userData.userinfo.userId);
          formData.append(
            "customerId",
            selectedCustomer?.value || selectedCustomer,
          );
          formData.append("orderItems", JSON.stringify(preparedFormFields));
          formData.append("totalCharges", chargestotal);
          formData.append("note", note);
          formData.append("orderPhoto", image ?? "");
          formData.append("orderDate", moment(orderDate).format("YYYY-MM-DD"));
          formData.append("orderId", Id);
          formData.append("isBillPaid", isBillPaid ? "1" : "0");

          //extra text filed append
          formData.append("customerReference", customerReference);

          await OrderUpdate(formData).then(async (res) => {
            if (res.status === 200) {
              // Fetch the appropriate HTML content based on printMode
              try {
                const fetchApi = printMode === "detail" 
                  ? getOrderPrintPreviousOrders(Id) 
                  : getOrderPrint(Id);
                
                const htmlRes = await fetchApi;
                if (htmlRes) setDetailHtmlContent(processDetailHtml(htmlRes, { hideQr: printMode === "total" }));
              } catch (error) {
                console.error(`Failed to fetch ${printMode} HTML:`, error);
              }

              // Use form state data directly for print (same as new order)
              const orderItemsForPrint = formFields.map((field) => ({
                item: field.item,
                type: field.type,
                charges: field.charges,
              }));

              setPrintData({
                customerName: customerName,
                customerPhone: customerPhone,
                orderId: Id,
                orderDate: orderDate.format("DD-MM-YYYY"),
                orderItems: orderItemsForPrint,
                totalCharges: chargestotal,
                preOrderArray: [],
                preOrderTotalCharges: 0,
              });
              setBillModal(true);
              const custId = selectedCustomer?.value || selectedCustomer;
              if (custId) {
                dispatch(addFilterState({ 
                  customerId: custId,
                  customerName: customerName,
                  searchQuery: "",
                  showStartDate: "",
                  showEndDate: "",
                  startDate: "",
                  endDate: ""
                }));
              }
              setMessage(res.message);
              queryClient.invalidateQueries(["order-data-list"]);
              queryClient.invalidateQueries(["customer-data"]);
              queryClient.invalidateQueries(["dashboard-cards"]);
              queryClient.invalidateQueries(["unsent-orderdata"]);
              queryClient.invalidateQueries(["items-not-picked-list"]);
              queryClient.invalidateQueries(["received-data-list"]);
              queryClient.invalidateQueries(["outstanding-list"]);
              queryClient.invalidateQueries(["weekly-order-list"]);
              queryClient.invalidateQueries(["yesterday-order-list"]);
            } else {
              swal("Error", res.message, "warning");
            }
          });
          setLoading(false);
          setImageError(false);
        }
      } else {
        if (
          image &&
          (image.type === "image/png" || image.type === "image/jpeg")
        ) {
          setImageError(false);
          setLoading(false);
        } else if (image) {
          setImageError(true);
          setLoading(false);
        } else {
          setImageError(false);
          setLoading(false);
        }
        if (!selectedCustomer || selectedCustomer == "0") {
          setCustomernameError(true);
          setLoading(false);
        }
        setLoading(false);
      }
    }
    setValidated(true);
    setLoading(false);
  };

  const handleFormChange = (event, index, item = "") => {
    if (item === "item") {
      debouncedItemSearch(event.target.value);
    }

    setSearch(event.target.value);
    let data = [...formFields];
    const fieldName = item !== "" ? item : event.target.name;
    const fieldValue = item !== "" ? event.target.value : event.target.value;

    data[index][fieldName] = fieldValue;

    setFormFields(data);

    if (event.target.name === "receivedBy") {
      let data = [...formFields];
      data[index]["receivedBy"] = event.target.value;
      setFormFields(data);
    }

    if (event.target.name === "charges") {
      const errors = [...formErrors];
      if (
        event.target.value === "0" ||
        event.target.value === "0.0" ||
        event.target.value === "0.00" ||
        event.target.value === "0.000"
      ) {
        errors[index] = "Charges must be grater than 0.";
      } else {
        errors[index] = "";
      }
      setFormErrors(errors);
    }

    if (event.target.name === "charges") {
      if (
        event.target.value.match(/^0(\.0{1,100})?$/) ||
        event.target.value.match(/^(-)?0+(\.0{1,3})?$/)
      ) {
        data[index]["chargesErr"] = true;
      } else {
        data[index]["chargesErr"] = false;
      }
    }

    if (item === "item") {
      if (
        !event.target.value ||
        event.target.value < 0 ||
        event.target.value === ""
      ) {
        data[index]["itemErr"] = true;
      } else {
        data[index]["itemErr"] = false;
      }
    }

    if (item !== "item") {
      if (
        event.target.name === "charges" &&
        event.target.value &&
        event.target.value !== 0
      ) {
        setchargesError(true);
      } else {
        setchargesError(false);
      }
    }
  };

  const handleCalculate = () => {
    let totalcharges = 0;
    formFields.map((e) => {
      totalcharges = totalcharges + parseFloat(e.charges);
    });
    setchargestotal(totalcharges);
    setTotalchargesErr(false);
  };

  const formreset = () => {
    window.location.reload();
    setImage(null);
    setImageError(false);
    setPreview(null);
    setSelectedCusomer("");
    setchargestotal(0);
    //setReceivedBy("");
    setFormFields([
      {
        item: "",
        charges: "",
        type: "",
        orderItemId: "-",
        isComplete: "0",
        isSent: "0",
        isReceived: "0",
        isReturn: "0",
        receivedBy: "",
        itemErr: false,
        chargesErr: false,
      },
    ]);
  };

  const addFields = () => {
    const lastItemType =
      formFields.length > 0 ? formFields[formFields.length - 1].type : "";

    let object = {
      item: "",
      charges: "",
      type: lastItemType,
      orderItemId: "-",
      isComplete: "0",
      isSent: "0",
      isReceived: "0",
      isReturn: "0",
      //receivedBy: receivedBy || "",
      receivedBy: "",
      itemErr: false,
      chargesError: false,
    };
    setFormFields([...formFields, object]);
  };

  const removeFields = (index, charges, orderItemId, isReceived) => {
    if (isReceived === true) {
      swal(
        "Warning",
        "You can not delete this item after all payment is received!",
        "warning",
      );
    } else {
      swal({
        title: "Are you sure?",
        text: "Are you sure that you want to delete?",
        icon: "warning",
        dangerMode: true,
        buttons: ["Cancel", "Ok"],
      }).then((willDelete) => {
        if (willDelete) {
          let data = [...formFields];
          data.splice(index, 1);
          setFormFields([...data]);
          setchargestotal(chargestotal - charges);
          deleteOrderItem({ orderItemId: orderItemId }).then((res) => {
            if (res.status === 200) {
              swal("Success", res.message, "success");
            } else {
              swal("Warning", res.message, "warning");
            }
          });
        }
      });
    }
  };

  const validationForm = (inputName, value) => {
    if (inputName === "note" && value && value.length > 500) {
      setcustomeNoteError(true);
    } else {
      setcustomeNoteError(false);
    }
    if (inputName === "Item Add" && value && value.length == "") {
      setAdditemError(true);
      setValidated(false);
      return false;
    } else {
      setAdditemError(false);
    }
    setValidated(true);
  };

  const handleFileChangeImage = (e) => {
    if (e.target.files) {
      if (
        e.target.files[0].type === "image/png" ||
        e.target.files[0].type === "image/jpeg"
      ) {
        setImage("");
        setImageError(false);
      } else {
        setImageError(true);
      }
      setImage(e.target.files[0]);
    }
  };

  // const getorderDataForEdit = async () => {
  //   let orderId = Id;
  //   await orderEditByIdApi(orderId)
  //     .then(
  //       async (res) => {
  //         if (res.status === 200) {
  //           console.log(
  //             "API Response receivedBy:",
  //             res.data.orderItems[0]?.receivedBy
  //           ); // Add this
  //           console.log("Customer Name:", res.data.customerName);
  //           var items = [];
  //           res.data.orderItems.forEach((element) => {
  //             items.push({
  //               item: element.item,
  //               type: element.type,
  //               charges: element.charges,
  //               orderItemId: element.orderItemId,
  //               isComplete: element.isComplete === 1 ? "1" : "0",
  //               isSent: element.isSent === 1 ? "1" : "0",
  //               isReceived: element.isReceived === 1 ? "1" : "0",
  //               isReturn: element.isReturn === 1 ? "1" : "0",
  //               //receivedBy: element.receivedBy || "",
  //               receivedBy:
  //                 element.isSent === 1 &&
  //                   (!element.receivedBy || element.receivedBy.trim() === "")
  //                   ? res.data.customerName
  //                   : element.receivedBy || "",

  //               orgIsReceived: element.isReceived === 1 ? true : false,
  //               orgIsReturned: element.isReturn === 1 ? true : false,
  //               itemErr: false,
  //               sentDate: element.sentDate,
  //             });
  //           });
  //           setFormFields(items);
  //           setNote(res.data.note);
  //           setorderDate(res.data.orderDate);

  //           setCustomerList([
  //             { value: res.data.customerId, label: res?.data?.customerName },
  //           ]);
  //           setSelectedCusomer({
  //             value: res?.data?.customerId,
  //             label: res?.data?.customerName,
  //           });
  //           setCustomerName(res.data.customerName);
  //           setCustomerPhone(res.data.customerPhone);

  //           //if backend sends it later in this condition if we didnt map then edit mode looks broken...
  //           setCustomerReference(res.data.customerReference || "");

  //           setchargestotal(res.data.totalCharges);
  //           setOrderPhoto(res.data.orderPhoto);
  //           setIsBillPaid(res.data.isBillPaid == "1" ? true : false);
  //           setReceivedBy(res.data.receivedBy || "");
  //         }
  //       },
  //       (err) => { }
  //     )
  //     .catch();
  // };

  const getorderDataForEdit = async () => {
    let orderId = Id;

    await orderEditByIdApi(orderId).then((res) => {
      if (res.status === 200) {
        const items = res.data.orderItems.map((element) => ({
          item: element.item,
          type: element.type,
          charges: element.charges,
          orderItemId: element.orderItemId,
          isComplete: element.isComplete === 1 ? "1" : "0",
          isSent: element.isSent === 1 ? "1" : "0",
          isReceived: element.isReceived === 1 ? "1" : "0",
          isReturn: element.isReturn === 1 ? "1" : "0",

          // ✅ FIX: normalize receivedBy here
          receivedBy:
            element.isSent === 1 &&
            (!element.receivedBy || element.receivedBy.trim() === "")
              ? res.data.customerName
              : element.receivedBy || "",

          orgIsReceived: element.isReceived === 1,
          orgIsReturned: element.isReturn === 1,
          itemErr: false,
          sentDate: element.sentDate,
        }));

        setFormFields(items);
        setNote(res.data.note);
        // Parse date as local time, allowing multiple typical API formats
        const parsedDate = moment(res.data.orderDate, [
          "DD-MM-YYYY hh:mm A",
          "YYYY-MM-DD",
          "DD-MM-YYYY",
          "YYYY-MM-DD HH:mm:ss",
          moment.ISO_8601,
        ]);
        setorderDate(
          parsedDate.isValid() && parsedDate.year() >= 2000
            ? parsedDate
            : moment(),
        );
        setCustomerReference(res.data.customerReference || "");
        setchargestotal(res.data.totalCharges);
        setOrderPhoto(res.data.orderPhoto);
        setIsBillPaid(res.data.isBillPaid == "1");

        setCustomerList([
          { value: res.data.customerId, label: res.data.customerName },
        ]);
        setSelectedCusomer({
          value: res.data.customerId,
          label: res.data.customerName,
        });
        setCustomerName(res.data.customerName);
        setCustomerPhone(res.data.customerPhone);
      }
    });
  };

  const handleAddCustomer = (e) => {
    let validate = true;
    e.preventDefault();
    let data = {
      userId: userId,
      customerName: name,
      customerPhone: contact,
    };
    if (data.customerName?.trim() === "" || data.customerName === undefined) {
      setNameErr("Please Enter Valid Name");
      validate = false;
    }
    if (data.customerPhone?.trim() === "" || data.customerPhone === undefined) {
      setContactErr("Please Inter Contact Number");
      validate = false;
    }

    if (
      !/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-.]?([0-9]{4})$/.test(
        data.customerPhone,
      )
    ) {
      setContactErr("Please enter 10 digit number");
      validate = false;
    }

    if (validate) {
      customerApi(data).then((res) => {
        if (res.status === 200) {
          // Fetch all customers without filter to ensure new customer appears
          fetchCustomerListApi1("").then((res) => {
            var data = res.data;
            var customerLive = [];
            data.forEach((element) => {
              customerLive.push({
                value: element.customerId,
                label:
                  element.customerName +
                  " " +
                  "(" +
                  element.customerPhone +
                  ")",
              });
            });
            setCustomerList(customerLive);
          });
          swal("Success", res.message, "success").then((Ok) => {
            if (Ok) {
              setName("");
              setContact("");
              setVisible(false);
            }
          });
        } else {
          swal("Warning", res.message, "warning");
        }
      });
    }
  };

  const handleIsReceived = (index) => {
    let data = [...formFields];
    const newValue = data[index].isReceived === "1" ? "0" : "1";

    // If checking "Is Received", keep existing receivedBy value
    data[index].isReceived = newValue;

    // Update API call
    if (Id && data[index].orderItemId) {
      checkIsReceived({
        orderId: Id,
        customerId: selectedCustomer?.value || selectedCustomer,
        orderItemId: data[index].orderItemId,
        isReceived: newValue === "1" ? 1 : 0,
        amount: data[index].charges,
        receivedBy: data[index].receivedBy,
      });
    }

    setFormFields(data);
  };

  const handleIsReturned = (index) => {
    let data = [...formFields];
    const currentValue = data[index]["isReturn"];
    const newValue = currentValue === "1" ? "0" : "1";

    data[index]["isReturn"] = newValue;
    setFormFields(data);
  };

  const handleIsComplete = (index) => {
    let data = [...formFields];
    const currentValue = data[index]["isComplete"];
    const newValue = currentValue === "1" ? "0" : "1";
    data[index]["isComplete"] = newValue;
    setFormFields(data);
  };

  const handleIsSent = (index) => {
    let data = [...formFields];
    const currentValue = data[index]["isSent"];
    const newValue = currentValue === "1" ? "0" : "1";
    data[index]["isSent"] = newValue;

    if (newValue === "1") {
      // Set sent date if not already set
      if (!data[index].sentDate) {
        data[index]["sentDate"] = moment().format("DD-MM-YYYY hh:mm A");
      }

      // AUTO-FILL: If receivedBy is empty, fill with customerName
      // Use a more reliable check
      const currentReceivedBy = data[index]["receivedBy"];
      if (
        (!currentReceivedBy || currentReceivedBy.trim() === "") &&
        customerName
      ) {
        // Make sure we're setting it properly
        data[index] = {
          ...data[index],
          receivedBy: customerName,
        };
      }
    }

    // Force immediate update
    setFormFields([...data]);
  };

  function handleCustomer(e) {
    // Extract customer name from the label (format: "Name (Phone)")
    const label = e.label;
    let customerNameFromLabel = label;

    // Remove phone number from label if present in parentheses
    const phoneMatch = label.match(/\(([^)]+)\)/);
    if (phoneMatch) {
      customerNameFromLabel = label.replace(/\s*\([^)]*\)\s*$/, "").trim();
    }

    setCustomerName(customerNameFromLabel);
    setSelectedCusomer(e);
    setCustomernameError("");

    // Update all items that are sent but have empty receivedBy
    let updatedFields = [...formFields];
    updatedFields = updatedFields.map((field) => {
      if (
        field.isSent === "1" &&
        (!field.receivedBy || field.receivedBy.trim() === "")
      ) {
        return {
          ...field,
          receivedBy: customerNameFromLabel,
        };
      }
      return field;
    });

    setFormFields(updatedFields);
  }

  const handleInputChange = (value) => {
    debouncedSearch(value);
  };

  // const handleReceivedByChange = (e) => {
  //   setReceivedBy(e.target.value);
  // };

  // const handleItemReceivedByChange = (e, index) => {
  //   let data = [...formFields];
  //   const value = e.target.value;

  //   // If value is empty and we have customer name, use it as default
  //   if (!value.trim() && customerName) {
  //     data[index]["receivedBy"] = customerName;
  //   } else {
  //     data[index]["receivedBy"] = value;
  //   }

  //   setFormFields(data);
  // };

  const handleItemReceivedByChange = (e, index) => {
    let data = [...formFields];
    data[index]["receivedBy"] = e.target.value; // Simply set whatever user types
    setFormFields(data);
  };

  return (
    <div>
      <CHeaderDivider />
      <CRow>
        <CCol md={12}>
          <h5 className="main-title ms-4">Order </h5>
        </CCol>
        {Id ? (
          <CCol xs={8}>
            <CBreadcrumb
              className="m-0 ms-4"
              style={{ "--cui-breadcrumb-divider": "'>'" }}
            >
              <CBreadcrumbItem>
                <Link to="/dashboard">Home</Link>
              </CBreadcrumbItem>
              <CBreadcrumbItem actives>Edit Order</CBreadcrumbItem>
            </CBreadcrumb>
          </CCol>
        ) : (
          <CCol xs={8}>
            <CBreadcrumb
              className="m-0 ms-4"
              style={{ "--cui-breadcrumb-divider": "'>'" }}
            >
              <CBreadcrumbItem>
                <Link to="/dashboard">Home</Link>
              </CBreadcrumbItem>
              <CBreadcrumbItem actives>New Order</CBreadcrumbItem>
            </CBreadcrumb>
          </CCol>
        )}

        <CCol xs={4}>
          <div className="text-end">
            <CButton
              color="info"
              size="sm"
              className="px-4 text-end text-white "
              type="button"
              style={{ marginTop: "-52px" }}
              onClick={(e) => window.history.back()}
            >
              Back
            </CButton>
          </div>
        </CCol>
      </CRow>
      <br />

      <CRow className="justify-content-center">
        <CCol md={12} lg={12} sm={12}>
          <CCard style={{ margin: "10px" }} className="mb-4">
            {Id ? (
              <CCardHeader>
                <strong>Edit Order</strong>
              </CCardHeader>
            ) : (
              <CCardHeader>
                <strong>New Order</strong>
              </CCardHeader>
            )}

            <CCardBody>
              <br />
              <div>
                <CForm
                  className="row g-3 needs-validation"
                  noValidate
                  validated={validated}
                  onSubmit={handleSubmit}
                  method="post"
                >
                  <CRow className="mb-3">
                    {/* <CCol md={7} sm={12} xs={12}>
                      <CFormLabel>Customer</CFormLabel>
                      &nbsp;&nbsp;
                      <div className="avatar bg-primary avatar-sm text-white">
                        <label
                          onClick={() => setVisible(!visible)}
                          className="text-white p-1"
                          type="button"
                          size="sm"
                          color="primary"
                        >
                          <CIcon icon={cilPlus} className="text-white" />
                        </label>
                      </div>
                      &nbsp;
                      <div className="">
                        <Select
                          options={customerlist}
                          className="text-start"
                          placeholder={
                            <div className="select-placeholder-text">
                              Select options
                            </div>
                          }
                          value={selectedCustomer}
                          onChange={handleCustomer}
                          onInputChange={handleInputChange}
                          isSearchable={true}
                          isDisabled={isBillPaid === 1 ? true : false}
                        />
                      </div>
                      <CFormFeedback invalid>
                        Please Choose a Customer Name.
                      </CFormFeedback>
                      {customernameError === true ? (
                        <>
                          <CFormFeedback className="errorMessage mb-3">
                            Please Choose a Customer Name.
                          </CFormFeedback>
                        </>
                      ) : null}
                    </CCol> */}

                    <CCol md={7} sm={12} xs={12}>
                      <CFormLabel>Customer</CFormLabel>
                      &nbsp;&nbsp;
                      <div className="avatar bg-primary avatar-sm text-white">
                        <label
                          onClick={() => setVisible(!visible)}
                          className="text-white p-1"
                          type="button"
                          size="sm"
                          color="primary"
                        >
                          <CIcon icon={cilPlus} className="text-white" />
                        </label>
                      </div>
                      &nbsp;
                      <div className="">
                        <Select
                          options={customerlist}
                          className="text-start"
                          placeholder={
                            <div className="select-placeholder-text">
                              Select options
                            </div>
                          }
                          value={selectedCustomer}
                          onChange={handleCustomer}
                          onInputChange={handleInputChange}
                          isSearchable={true}
                          isDisabled={isBillPaid === 1 ? true : false}
                        />
                      </div>
                      <CFormFeedback invalid>
                        Please Choose a Customer Name.
                      </CFormFeedback>
                      {customernameError === true ? (
                        <>
                          <CFormFeedback className="errorMessage mb-3">
                            Please Choose a Customer Name.
                          </CFormFeedback>
                        </>
                      ) : null}
                    </CCol>

                    <CCol md={4} sm={12}>
                      <CFormLabel>Customer Reference</CFormLabel>
                      <CFormInput
                        type="text"
                        placeholder="Enter reference"
                        value={customerReference}
                        onChange={(e) => setCustomerReference(e.target.value)}
                      />
                    </CCol>

                    <CCol md={1} sm={1} xs={2}></CCol>

                    <CCol md={4} sm={12}>
                      <CFormLabel>Order Date</CFormLabel>
                      <CInputGroup className="mb-3">
                        <Datetime
                          value={orderDate}
                          onChange={handleDateChange}
                          dateFormat="DD-MM-YYYY"
                          timeFormat="HH:mm A"
                        />
                      </CInputGroup>
                    </CCol>

                    <CCol md={12} sm={12} xs={12}>
                      <div className="form-check ">
                        <input
                          className="form-check-input"
                          onChange={(e) => setIsBillPaid(e.target.checked)}
                          type="checkbox"
                          name="checkbox"
                          checked={isBillPaid}
                          id="flexCheckChecked"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexCheckChecked"
                        >
                          Is Bill Paid
                        </label>
                      </div>
                    </CCol>

                    <CModal
                      alignment="center"
                      scrollable
                      visible={visible}
                      onClose={() => setVisible(false)}
                    >
                      <CModalHeader>
                        <CModalTitle>Order Add Customer</CModalTitle>
                      </CModalHeader>
                      <CModalBody>
                        <CContainer>
                          <CRow>
                            <CCol md={12} sm={12} lg={12}>
                              <form className="">
                                <div className="">
                                  <label>Name</label>
                                  <input
                                    type="name"
                                    className="form-control"
                                    onChange={(e) => {
                                      setName(e.target.value);
                                      setNameErr("");
                                    }}
                                    placeholder="Enter Name"
                                  />
                                  <span className="text-danger">{nameErr}</span>
                                </div>
                                <div className="mt-3">
                                  <label>Contact</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    onChange={(e) => {
                                      setContact(e.target.value);
                                      if (String(e.target.value).length != 10) {
                                        setContactErr(
                                          "Please Enter 10 Digit Number",
                                        );
                                      } else {
                                        setContactErr("");
                                      }
                                    }}
                                    placeholder="Enter Contact"
                                  />
                                  <span className="text-danger">
                                    {contactErr}
                                  </span>
                                </div>
                                <div className="mt-3">
                                  <button
                                    className="btn btn-primary"
                                    onClick={handleAddCustomer}
                                  >
                                    Add
                                  </button>
                                </div>
                              </form>
                              <br />
                            </CCol>
                          </CRow>
                        </CContainer>
                      </CModalBody>
                    </CModal>
                  </CRow>

                  <CCol md={12} sm={12} xs={12}>
                    <CCardHeader className="header-item">
                      <strong>Add Items</strong>
                      &nbsp; &nbsp;
                    </CCardHeader>
                  </CCol>
                  <br />
                  <br />

                  {formFields.map((form, index) => {
                    return (
                      <div className="item-background" key={index}>
                        {/* Row 1: All Input Fields in One Line */}
                        <CRow className="align-items-end mb-2">
                          {/* Item */}
                          {/* <CCol lg={5} md={5} sm={3} xs={12} className="mb-2">
                            <CFormLabel className="mb-2">
                              Item {index + 1} :
                            </CFormLabel>
                            <input
                              list="browsers"
                              name="item"
                              id="item"
                              className="form-select"
                              value={form.item}
                              placeholder="Select Item"
                              onChange={(event) => {
                                handleFormChange(event, index, "item");
                              }}
                            />
                            <datalist id="browsers">
                              {itemorderList.map((data, idx) => (
                                <option
                                  key={idx}
                                  name="item"
                                  value={data.value}
                                />
                              ))}
                            </datalist>
                            {form.itemErr === true ? (
                              <CFormFeedback className="itemError">
                                Please Select Item.
                              </CFormFeedback>
                            ) : null}
                          </CCol> */}

                          <CCol lg={5} md={5} sm={3} xs={12} className="mb-2">
                            <CFormLabel className="mb-2">
                              Item {index + 1} :
                            </CFormLabel>

                            {/* 
    FIX:
    - Each datalist must have a UNIQUE id
    - Previously all rows used id="browsers", causing dropdown to break
    - Using index ensures proper list binding per row
  */}
                            <input
                              list={`browsers-${index}`}
                              name="item"
                              id={`item-${index}`}
                              className="form-select"
                              title={form.item}
                              value={form.item}
                              placeholder="Select Item"
                              onChange={(event) => {
                                handleFormChange(event, index, "item");
                              }}
                            />

                            {/* Unique datalist per item row */}
                            <datalist id={`browsers-${index}`}>
                              {itemorderList.map((data, idx) => (
                                <option key={idx} value={data.value} />
                              ))}
                            </datalist>

                            {form.itemErr === true ? (
                              <CFormFeedback className="itemError">
                                Please Select Item.
                              </CFormFeedback>
                            ) : null}
                          </CCol>

                          {/* Type */}
                          <CCol lg={2} md={2} sm={2} xs={12} className="mb-2">
                            <CFormLabel className="mb-2">Type :</CFormLabel>
                            <CFormSelect
                              aria-describedby="validationTooltip04Feedback"
                              feedbackInvalid="Please select type."
                              id="validationTooltip04"
                              name="type"
                              value={form.type}
                              onChange={(event) =>
                                handleFormChange(event, index)
                              }
                              required
                            >
                              <option value="">Choose</option>
                              <option value="gold">Gold</option>
                              <option value="silver">Silver</option>
                              <option value="1gm">1 Gram</option>
                            </CFormSelect>
                          </CCol>

                          {/* Charges */}
                          <CCol lg={2} md={2} sm={2} xs={12} className="mb-2">
                            <CFormLabel className="mb-2">Charges :</CFormLabel>
                            <CFormInput
                              type="number"
                              disabled={form.isReceived === "1"}
                              id="validationCustom02"
                              onChange={(event) =>
                                handleFormChange(event, index)
                              }
                              value={form.charges}
                              name="charges"
                              placeholder="Charges"
                              min="0"
                            />
                            {form.chargesErr == true ? (
                              <CFormFeedback className="itemError">
                                Please Enter valid amount.
                              </CFormFeedback>
                            ) : null}
                          </CCol>

                          {/* Received By */}
                          <CCol lg={3} md={3} sm={5} xs={12} className="mb-2">
                            <CFormLabel className="mb-2">
                              Received By :
                            </CFormLabel>
                            <CFormInput
                              type="text"
                              value={form.receivedBy || ""}
                              onChange={(e) =>
                                handleItemReceivedByChange(e, index)
                              }
                              onBlur={(e) => {
                                if (
                                  Id &&
                                  form.orderItemId &&
                                  form.orderItemId !== "-"
                                ) {
                                  checkIsReceived({
                                    orderId: Id,
                                    customerId:
                                      selectedCustomer?.value ||
                                      selectedCustomer,
                                    orderItemId: form.orderItemId,
                                    isReceived: form.isReceived === "1" ? 1 : 0,
                                    amount: form.charges,
                                    receivedBy: e.target.value,
                                  });
                                }
                              }}
                              placeholder="Person who received"
                              disabled={form.isSent !== "1"}
                              style={{
                                fontWeight:
                                  form.isSent === "1" ? "bold" : "normal",
                              }}
                            />
                          </CCol>
                        </CRow>

                        {/* Row 3: Status Checkboxes */}

                        <CRow className="align-items-center g-3">
                          {/* Is Complete */}
                          <CCol lg={2} md={2} sm={6} xs={6} className="px-2">
                            <div className="form-check text-nowrap">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                onChange={() => handleIsComplete(index)}
                                checked={form.isComplete === "1"}
                                id={`isComplete-${index}`}
                              />
                              <CFormLabel htmlFor={`isComplete-${index}`}>
                                Is Complete
                              </CFormLabel>
                            </div>
                          </CCol>

                          {/* Is Sent */}
                          <CCol lg={2} md={2} sm={6} xs={6} className="px-2">
                            <div className="form-check text-nowrap">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                onChange={() => handleIsSent(index)}
                                checked={form.isSent === "1"}
                                id={`isSent-${index}`}
                              />
                              <CFormLabel htmlFor={`isSent-${index}`}>
                                Is Sent
                              </CFormLabel>
                            </div>
                            {form.isSent === "1" && form.sentDate && (
                              <div
                                style={{
                                  fontSize: "11px",
                                  color: "#6c757d",
                                  marginTop: "2px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {form.sentDate}
                              </div>
                            )}
                          </CCol>

                          {/* Is Returned */}
                          <CCol lg={2} md={2} sm={6} xs={6} className="px-2">
                            <div className="form-check text-nowrap">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                onChange={() => handleIsReturned(index)}
                                checked={form.isReturn === "1"}
                                id={`isReturn-${index}`}
                              />
                              <CFormLabel htmlFor={`isReturn-${index}`}>
                                Is Returned
                              </CFormLabel>
                            </div>
                          </CCol>

                          {/* Is Received */}
                          <CCol lg={2} md={2} sm={6} xs={6} className="px-2">
                            <div className="form-check text-nowrap">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                onChange={() => handleIsReceived(index)}
                                checked={form.isReceived === "1"}
                                id={`isReceived-${index}`}
                              />
                              <CFormLabel htmlFor={`isReceived-${index}`}>
                                Is Received
                              </CFormLabel>
                            </div>
                          </CCol>

                          {/* Trash Button */}
                          <CCol
                            lg={2}
                            md={2}
                            sm={12}
                            xs={12}
                            className="px-2 text-end"
                          >
                            <CButton
                              color="danger"
                              size="sm"
                              disabled={formFields.length === 1}
                              onClick={() =>
                                removeFields(
                                  index,
                                  form.charges,
                                  form.orderItemId,
                                  form.isReceived === "1",
                                )
                              }
                            >
                              <CIcon icon={cilTrash} />
                            </CButton>
                          </CCol>
                        </CRow>
                      </div>
                    );
                  })}

                  <CRow className="mt-3">
                    <CCol md={8} sm={12} xs={12} className="button-plus">
                      <CButton
                        color="danger"
                        className="text-white mt-4"
                        onClick={addFields}
                        type="button"
                      >
                        <CIcon icon={cilPlus} className="text-white " /> Items
                      </CButton>
                    </CCol>

                    <CCol
                      md={4}
                      sm={12}
                      xs={10}
                      className="total-Charges d-flex flex-column gap-2"
                    >
                      <div>
                        <CButton
                          color="primary"
                          className="text-white mt-4 px-2 py-1"
                          type="button"
                          onClick={handleCalculate}
                        >
                          Calculate
                        </CButton>
                      </div>
                      <div>
                        <CFormLabel htmlFor="validationCustom03">
                          Total Charges :
                        </CFormLabel>
                        <CFormInput
                          type="number"
                          id="validationCustom03"
                          name="total_number"
                          value={chargestotal}
                          placeholder="Total"
                          readOnly
                        />
                        {totalchargesErr == true ? (
                          <>
                            <CFormFeedback className="itemError">
                              Please calculate total amount.
                            </CFormFeedback>
                          </>
                        ) : null}
                      </div>
                    </CCol>
                  </CRow>
                  <CCol md={8} sm={12} xs={12}></CCol>
                  <hr />
                  <CRow className="mt-3">
                    <CForm>
                      <CCol md={7} sm={12} xs={12}>
                        <CFormLabel htmlFor="exampleFormControlTextarea1">
                          Note
                        </CFormLabel>
                        <CFormTextarea
                          id="exampleFormControlTextarea1"
                          name="note"
                          rows={3}
                          text=""
                          onChange={(e) => {
                            setNote(e.target.value);
                            validationForm(e.target.name, e.target.value);
                          }}
                          value={note}
                        ></CFormTextarea>
                        {customeNoteError === true ? (
                          <>
                            <CFormFeedback className="errorMessage-customer">
                              Please Enter 500 Characters
                            </CFormFeedback>
                          </>
                        ) : null}
                      </CCol>
                    </CForm>
                  </CRow>

                  <CRow className="mt-3">
                    <CCol md={7} sm={12} xs={12}>
                      <CFormLabel htmlFor="validationCustom02">
                        Image
                      </CFormLabel>
                      <CFormInput
                        name="image"
                        type="file"
                        id="validationTextarea"
                        aria-label="file example"
                        onChange={handleFileChangeImage}
                      />
                      {imageError === true ? (
                        <>
                          <CFormFeedback className="errorMessage">
                            Please upload image only
                          </CFormFeedback>
                        </>
                      ) : null}
                    </CCol>
                  </CRow>
                  <CCol xs={12}>
                    {preview ? (
                      <img
                        src={preview}
                        className="imagePreview"
                        alt="Preview"
                      />
                    ) : OrderPhoto &&
                      OrderPhoto != "" &&
                      OrderPhoto != "No Image" ? (
                      <img
                        src={OrderPhoto}
                        className="imagePreview"
                        alt="Order"
                      />
                    ) : null}
                  </CCol>

                  <CCol
                    md={12}
                    sm={12}
                    className="d-flex justify-content-end align-items-end gap-3"
                  >
                    <CButton
                      color="primary"
                      disabled={imageError || loading}
                      type="submit"
                      onClick={() => {
                        setPrintMode("total");
                        if (!selectedCustomer || selectedCustomer === "0") {
                          setCustomernameError(true);
                          setLoading(false);
                        } else {
                          setCustomernameError(false);
                          setLoading(false);
                        }
                      }}
                    >
                      {loading ? "wait.." : "Total"}
                    </CButton>
                    
                    <CButton
                      className="ms-3"
                      color="primary"
                      disabled={imageError || loading}
                      type="submit"
                      onClick={() => {
                        setPrintMode("detail");
                        if (!selectedCustomer || selectedCustomer === "0") {
                          setCustomernameError(true);
                          setLoading(false);
                        } else {
                          setCustomernameError(false);
                          setLoading(false);
                        }
                      }}
                    >
                      {loading ? "wait.." : "Detail"}
                    </CButton>

                    {/* {Id ? null : (
                      <CButton
                        color="link"
                        className="text-decoration-none"
                        onClick={formreset}
                      >
                        Reset
                      </CButton>
                    )} */}
                  </CCol>
                </CForm>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
        <CModal
          className="modal"
          alignment="center"
          scrollable
          size={printMode === "detail" ? "lg" : ""}
          visible={BillModal}
          onClose={() => setBillModal(false)}
        >
          <CModalTitle className="text-success mt-2 ms-2">Success</CModalTitle>
          <hr />
          <CModalBody>
            {detailHtmlContent ? (
              <div dangerouslySetInnerHTML={{ __html: detailHtmlContent }} />
            ) : (
              <div className="text-center p-5">
                <strong>Loading print preview...</strong>
              </div>
            )}
          </CModalBody>
          <CModalFooter>
            {Id !== undefined ? (
              <button
                className="btn btn-info me-2"
                onClick={() => {
                  navigate("/order/print/" + Id, { state: { printMode } });
                }}
              >
                Print
              </button>
            ) : (
              <button
                className="btn btn-info me-2"
                onClick={() => {
                  navigate("/order/print/" + OrderId, { state: { printData, printMode } });
                }}
              >
                Print
              </button>
            )}
            <button
              className="btn btn-danger"
              onClick={() => {
                navigate("/customerbilling");
              }}
            >
              Go Back
            </button>
          </CModalFooter>
        </CModal>
      </CRow>
    </div>
  );
}

export default OrderTable;
